import HomeLayout from "../layout/HomeLayout";
import "../i18n/i18n";
import React, {useEffect} from "react";
import {useRouter} from "next/router";

const Home = ({ children }) => {
	const router = useRouter();

	useEffect(() => {
		if (!children) {
			router.push("/entry", "/");
		}
	}, []);

	return (
		<div>
			{ children }
		</div>
	);
};
Home.getLayout = function getLayout(page) {
	console.log("init");
	return (
		<HomeLayout>
			{page}
		</HomeLayout>
	);
};
export default Home;
